import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useBranding } from '../../../branding'
import CopyToClipboard from '../../basics/CopyToClipboard/CopyToClipboard'
import generateOnboardingPdf from './generateOnboardingPdf'

/**********************************************************************
 * OnboardingDialog
 **********************************************************************/
export const OnboardingDialog = React.memo(function OnboardingDialog({
  username,
  password,
  link,
  name,
}: {
  username: string
  password: string
  link: string
  name: string
}) {
  const { t } = useTranslation()

  const { logoUrl, clientCode } = useBranding()

  const [pdfUrl, setPdfUrl] = useState<string | null>(null)

  useEffect(() => {
    generateOnboardingPdf({
      uiUrl: new URL('/', link).toString(),
      username,
      password,
      link,
      customLogoDataUrl: logoUrl,
      customDefaultClientCode: clientCode,
    }).then((blob) => setPdfUrl(blob))
  }, [])

  return (
    <>
      <p>{t('login password.password reset url is')}</p>
      <CopyToClipboard text={link} />
      <p>{t('login password.initial login credentials are')}</p>
      <CopyToClipboard
        text={t('login password.initial login credentials are {username} and {password}', { username, password })}
      />
      {pdfUrl && (
        <a href={pdfUrl!} download={`Onboarding ${name}.pdf`}>
          {t('login password.cta download onboarding instructions as pdf')}
        </a>
      )}
    </>
  )
})
